import { Box } from '@mui/material';
import React from 'react';
import { styles } from './styles';

const CUSTOM_HEIGHT_BY_SLIDES_AMOUNT = {
  6: 290,
  7: 320,
};

export default function VerticalSliderComponent({
  slides,
  marginTops,
  hasAiCard = false,
  isCareerCenter = false,
}) {
  const height = CUSTOM_HEIGHT_BY_SLIDES_AMOUNT[slides.length] ?? 170;
  marginTops = marginTops = [
    '-50px',
    ...(hasAiCard ? ['-170px'] : []),
    ...marginTops,
  ];

  return (
    <Box sx={styles.wrapper}>
      {slides && (
        <>
          {slides.map((Slide, index) => (
            <Box
              key={index}
              sx={styles.slide(marginTops, index, height, isCareerCenter)}
            >
              <Slide />
            </Box>
          ))}
        </>
      )}
    </Box>
  );
}
